import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ArticlesGrid from "./components/ArticlesGrid";
import SEOSection from "./components/SEOSection";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  const siteUrl = "https://pandabuy.watch";

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: "PandabuySpreadsheet",
              url: siteUrl,
              description:
                "The ultimate curated pandabuy finds database updated daily with community-verified product links across shoes, hoodies, t-shirts, jackets, accessories, and more.",
              potentialAction: {
                "@type": "SearchAction",
                target: {
                  "@type": "EntryPoint",
                  urlTemplate: "https://kaspreadsheet.com/search-{search_term}/name/Shoes.html",
                },
                "query-input": "required name=search_term",
              },
            },
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              name: "PandabuySpreadsheet",
              url: siteUrl,
              logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg",
              description:
                "The ultimate curated Pandabuy finds database updated daily with community-verified product links and spreadsheets.",
              sameAs: ["https://kaspreadsheet.com"],
            },
          ]),
        }}
      />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ArticlesGrid />
      <SEOSection />
      <Testimonials />
      <CTASection />
      <Footer />
    </main>
  );
}